import React from "react";
import { useNavigate } from "react-router-dom";

// Image Imports
import img1 from "../../assets/images/ft.jpg";
import img2 from "../../assets/images/bg.jpg";
import img3 from "../../assets/images/pt.jpg";
import img4 from "../../assets/images/ra.jpg";
import img5 from "../../assets/images/pt4.jpg";

// ==========================================
// 1. HELPER COMPONENT
// ==========================================
function PortfolioItem({ heightClass, imageSrc, altText }) {
  return (
    <div
      className={`relative rounded-2xl overflow-hidden transition-all duration-500 hover:scale-[1.03] animate-fadeIn ${heightClass}`}
      style={{
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(0,245,160,0.25)",
        boxShadow: "0 0 25px rgba(0,245,160,0.15)",
      }}
    >
      <img
        src={imageSrc}
        alt={altText || "Portfolio Item"}
        className="w-full h-full object-cover"
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          boxShadow: "0 0 30px rgba(0,245,160,0.4)",
          border: "1px solid rgba(0,245,160,0.25)",
          borderRadius: "16px",
        }}
      />
    </div>
  );
}

// ==========================================
// 2. MAIN COMPONENT
// ==========================================
export default function Uidesign() {
  const navigate = useNavigate();

  const displayImages = [
    { id: 1, src: img1, height: "h-56" },
    { id: 2, src: img2, height: "h-56" },
    { id: 3, src: img3, height: "h-48" },
    { id: 4, src: img4, height: "h-60" },
    { id: 5, src: img5, height: "h-[28rem]" },
    { id: 6, src: img1, height: "h-56" },
  ];

  const gradientText = {
    background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-20 text-white relative">
      
      {/* Mobile Header */}
      <h2
        className="text-4xl font-extrabold mb-10 text-center lg:hidden"
        style={gradientText}
      >
        DESIGNING
      </h2>

      {/* Sidebar Header */}
      <h2
        className="hidden lg:block absolute top-2/3 left-0 -translate-y-1/2 text-6xl font-extrabold tracking-wide"
        style={{
          ...gradientText,
          transform: "rotate(-90deg) translateY(50%)",
          transformOrigin: "left center",
        }}
      >
        DESIGNING
      </h2>

      {/* Gallery */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto items-start">
        {displayImages.map((item) => (
          <PortfolioItem
            key={item.id}
            imageSrc={item.src}
            heightClass={item.height}
          />
        ))}
      </div>

      <p className="mt-14 text-center text-white/70 max-w-3xl mx-auto">
        Your visual identity defines how the world sees your brand...
      </p>

      {/* Button */}
      <div className="mt-10 text-center">
        <button
          onClick={() => navigate("/ui-page")}
          className="group font-semibold text-[#00F5A0] transition-all flex items-center gap-2 mx-auto bg-[#00F5A0]/5 px-8 py-3 rounded-full border border-[#00F5A0]/20 hover:bg-[#00F5A0]/10 hover:border-[#00F5A0]/50"
        >
          View Full UI Gallery <span className="text-xl">→</span>
        </button>
      </div>
    </section>
  );
}